import { QaToolHeader } from "@/components/ui/QaToolHeader";
import { useIsLoginPage } from "@/hooks/use-is-login-page";
import { usePathnameParts } from "@/hooks/use-pathname-parts";
import { useSidebarStore } from "@/stores/sidebar-store";
import { pretty } from "@/utils/pretty";
import { ChevronRight } from "@mui/icons-material";
import { ButtonBase, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router";

export function PageHeader() {
  const parts = usePathnameParts();

  const { open, disabled } = useSidebarStore();

  const isLoginPage = useIsLoginPage();

  return (
    <>
      <ButtonBase
        sx={{
          display: open && !disabled ? "none" : "block",
        }}
        disabled={isLoginPage}
        href="/"
        LinkComponent={(props) => <RouterLink {...props} to={props.href} />}
      >
        <QaToolHeader
          sx={{
            px: 0.5,
            py: 0.5,
            "&:hover": {
              backgroundColor: "action.hover",
              borderRadius: 1,
            },
          }}
        />
      </ButtonBase>
      {parts[0] && (
        <>
          <ChevronRight
            fontSize="small"
            color="disabled"
            sx={{
              display: open && !disabled ? "none" : "block",
            }}
          />
          <ButtonBase
            href={`/${parts[0]}`}
            disabled={
              isLoginPage || parts[0] === "images" || parts[0] === "masks"
            }
            LinkComponent={(props) => <RouterLink {...props} to={props.href} />}
          >
            <Typography
              variant="h6"
              sx={{
                px: 0.5,
                py: 0.5,
                "&:hover": {
                  backgroundColor: "action.hover",
                  borderRadius: 1,
                },
              }}
            >
              {pretty(parts[0], "dashes")}
            </Typography>
          </ButtonBase>
        </>
      )}
      {parts[1] && (
        <>
          <ChevronRight fontSize="small" color="disabled" />
          <Typography
            variant="h6"
            sx={{
              px: 0.5,
              py: 0.5,
            }}
          >
            Details
          </Typography>
        </>
      )}
    </>
  );
}
